import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationWrapperService } from '../services/authentication-wrapper.service';

@Injectable({ providedIn: 'root' })
export class AuthInterceptorService implements HttpInterceptor {
  private readonly authenticationWrapperService = inject(AuthenticationWrapperService);

  /**   * Intercept HTTP request and inject Bearer Token to header
   *
   *
   * @param request HTTP request
   * @param next HTTP handler to handle request after interceptor is done
   *
   * */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authenticationWrapperService.getToken();
    if (token) {
      const idpHeaders = request.headers.set('Authorization', 'Bearer ' + token);
      request = request.clone({ headers: idpHeaders });
      return next.handle(request);
    } else {
      return next.handle(request);
    }
  }
}
